export const SIZES = {
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
} as const

export const ICON_SIZE_MAP = {
  XS: 'Mini',
  S: 'ExtraSmall',
  M: 'Small',
  L: 'Medium',
  XL: 'Large',
} as const
